import { Organisation, ValidationIssue } from 'api'
import { Locale, Translation } from 'locale'
import { getIssuesForField } from 'model'
import React from 'react'
import { KeyValuePair, MultiTextInput } from 'view/components/inputs'

interface GfidPanelComponentProps {
  organisation: Organisation
  onUpdate: (organisation: Partial<Organisation>) => unknown
  validationIssues: ValidationIssue[]
  readOnly: boolean
}
export const GfidPanelComponent: React.FC<GfidPanelComponentProps> = props => {
  const { organisation, onUpdate, validationIssues, readOnly } = props

  const gfidKeyValuePairs: KeyValuePair<string>[] = organisation.gfidCodes.map(gfid => ({ key: gfid, value: gfid }))

  const handleUpdate = (newGfidKeyValuePairs: KeyValuePair<string>[]) => {
    const update = {
      gfidCodes: [...newGfidKeyValuePairs.map(v => v.value.toUpperCase())]
    }
    onUpdate(update)
  }

  return (
    <MultiTextInput
      value={gfidKeyValuePairs}
      onUpdate={handleUpdate}
      validationIssues={getIssuesForField(validationIssues, 'gfidCodes')}
      canClear={true}
      placeholder={Locale.translate(Translation.SC_ADD_GFID)}
      clearButtonLabel={Locale.translate(Translation.SC_REMOVE_GFIDS)}
      maxLength={10}
      readOnly={readOnly}
      readOnlyOptions={true}
      dataTestId={'GfidPanel-TextInput-AddGfid'}
    />
  )
}
